import './helpers.js';
import './config.js';
import { b as registerComponent, u as use } from './plugins-678fd904.js';
import './Icon-631c5342.js';
import './FormElementMixin-97156cdb.js';
import './Input-90b0bfda.js';
import { _ as __vue_component__ } from './Autocomplete-7b2a81a9.js';
export { _ as OAutocomplete } from './Autocomplete-7b2a81a9.js';

const Plugin = {
  install(Vue) {
    registerComponent(Vue, __vue_component__);
  }

};
use(Plugin);

export default Plugin;
